module.exports = __webpack_public_path__ + "static/media/DigiSpel.98fe0621.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/DigiSpel.jpg
// module id = 374
// module chunks = 3